import { use18n } from 'src/utils/v2_helper/common';
import { computed, ref } from 'vue';



export function useVerify() {
  const { $t } = use18n();

  const captcha = ref('')
  const verifing = ref(false);
  const verifyErrmsg = ref('')
  const channel = ref('WHATSAPP'); // WHATSAPP / SMS

  const typeTip = computed(() =>
    (channel.value === 'WHATSAPP' ? $t('login.whatsappTip') : $t('login.smsTip'))
  )

  return { channel, captcha, verifing, verifyErrmsg, typeTip }
}
